import { render, staticRenderFns } from "./Disposable.vue?vue&type=template&id=6308e4a1&scoped=true&"
import script from "./Disposable.vue?vue&type=script&lang=js&"
export * from "./Disposable.vue?vue&type=script&lang=js&"
import style0 from "./Disposable.vue?vue&type=style&index=0&id=6308e4a1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6308e4a1",
  null
  
)

export default component.exports